import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { TextArea } from '../../../../components/form-elements/TextArea';
import { TerreHautePaperworkDocument } from '../../../../models/production/terrehaute-paperwork-document';

export const TerreHautePaperwork = () => {

    const [isOpen, setIsOpen] = React.useState(false);
    const [runIds, setRunIds] = React.useState('');
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setRunIds('');
        setIsOpen(false);
    };

    /**
     * Format the dates and initiate the run credit report command
     */
    const runReport = () => {

        if (runIds && runIds.length > 0) {

            const idList = runIds.split('\n');
            const idListStr = idList.reduce((accum: string, curr: string) => {

                const parseResult = Number.parseInt(curr, 10);
                if (isNaN(parseResult)) {
                    return accum;
                }
                else {
                    return accum += curr + ',';
                }
            }, '');

            const req = new TerreHautePaperworkDocument(idListStr.substr(0, idListStr.length - 1));
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    const onRunIdsChange = (e: any) => {
        setRunIds(e.target.value);
    };

    return <React.Fragment>
        <div className="report-card-wrap blue">
            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col">
                            <h3>Terre Haute Paperwork</h3>
                            <p>Export production paperwork for a list of runs.</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <DialogTrigger
                                onClick={onOpenClick}
                                text="Run Report" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog
            open={isOpen}
            className="report-dialog"
            onClose={onCloseClick}
            maxWidth="md"
            aria-labelledby="form-dialog-title">

            <DialogHeader>
                <h1>Production Run Export</h1>
            </DialogHeader>

            <DialogContent>
                <div className="row">
                    <div className="col">
                        <p>Provide a list run IDs, one per line, to include in the paperwork bundle.</p>
                    </div>
                </div>
                <div className="row justify-content-around">
                    <div className="col">
                        <TextArea
                            id="runIds"
                            className="reporting-shipmentexport-textarea"
                            label="Run IDs"
                            allowReturn={true}
                            value={runIds}
                            onChange={onRunIdsChange} />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <FlatButton
                    id="accountmateNoBtn"
                    text="Cancel"
                    classes="negative"
                    onBtnClick={onCloseClick} />
                <FlatButton
                    id="accountmateYesBtn"
                    text="Go"
                    disable={runIds.length === 0}
                    classes="positive"
                    onBtnClick={runReport} />
            </DialogActions>
        </Dialog>
    </React.Fragment>;

};
